import { OWNER_WITH_CUSTOMER_AGENT_PRIORITY } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import { groupOwnerReferences } from './ownerOptionsGrouping';
const FORMAT_LOADED_REFERENCES_BY_TYPE = {
  [OWNER_WITH_CUSTOMER_AGENT_PRIORITY]: groupOwnerReferences
};
export const getFormatLoadedReferencesByType = referenceType => FORMAT_LOADED_REFERENCES_BY_TYPE[referenceType];